import { STARTER_SUITE_ONBOARDING_SCOPES, PRO_SUITE_ONBOARDING_SCOPES, ENTERPRISE_SUITE_ONBOARDING_SCOPES, ONBOARDING_PRO_SCOPES, ONBOARDING_ENTERPRISE_SCOPES } from '../scopeConstants';
import { includesAll, excludesAll } from './arrayUtils';
import { getHasCoreEnterpriseSeat, getHasCoreProSeat } from './seatProducts';
export const getHasCrmSuiteStarter = scopes => {
  return includesAll(scopes, STARTER_SUITE_ONBOARDING_SCOPES) && excludesAll(scopes, ONBOARDING_PRO_SCOPES) && excludesAll(scopes, ONBOARDING_ENTERPRISE_SCOPES);
};
export const getHasCrmSuitePro = scopes => {
  return includesAll(scopes, PRO_SUITE_ONBOARDING_SCOPES) && excludesAll(scopes, ENTERPRISE_SUITE_ONBOARDING_SCOPES);
};
export const getHasCrmSuiteEnterprise = scopes => {
  return includesAll(scopes, ENTERPRISE_SUITE_ONBOARDING_SCOPES);
};
export const getHasOnlySmartCrmEnterprise = scopes => {
  return getHasCoreEnterpriseSeat(scopes) && excludesAll(scopes, ENTERPRISE_SUITE_ONBOARDING_SCOPES);
};
export const getHasOnlySmartCrmPro = scopes => {
  return getHasCoreProSeat(scopes) && excludesAll(scopes, PRO_SUITE_ONBOARDING_SCOPES) && excludesAll(scopes, ENTERPRISE_SUITE_ONBOARDING_SCOPES);
};